module.exports = __webpack_public_path__ + "static/media/Azelf_gaussian2.99a4c1da.png";